// Validation Utility Functions

/**
 * Validate email format (RFC 5322 compliant)
 * @param {string} email - Email address to validate
 * @returns {boolean} - True if valid email format
 */
export function isValidEmail(email) {
    if (!email || typeof email !== 'string') return false;
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
    return email.length <= 254 && emailRegex.test(email);
}

// Alias for backward compatibility
export const validateEmail = isValidEmail;

/**
 * Validate number within range
 * @param {string|number} value - Value to validate
 * @param {number} [min] - Minimum value (inclusive)
 * @param {number} [max] - Maximum value (inclusive)
 * @returns {boolean} - True if valid number within range
 */
export function validateNumber(value, min, max) {
    const num = parseInt(value);
    if (isNaN(num)) return false;
    if (min !== undefined && num < min) return false;
    if (max !== undefined && num > max) return false;
    return true;
}
